<template>
    <div v-if="focusedWell" class="print-well">
        <print-page-header :is-loading="isImageLoading" />
        <div class="print_content landscape">
            <div class="page">
                <print-header />
                <print-sub-header />
                <div class="well-body">
                    <div class="left">
                        <print-well-detail />
                        <print-well-score-metrics />
                        <print-clinic-notes />
                    </div>
                    <div class="center">
                        <print-well-annotated-event-table />
                    </div>
                    <div class="right">
                        <div class="well-status-container">
                            <well-status-controls :well="focusedWell" class="focused my-2" />
                        </div>
                        <div class="img-container">
                            <img :src="imageUrl" alt="" @load="isImageLoading = false" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Utils from '../../../business/utils/Utils'
import WellStatusControls from '../../components/common/WellStatusControls'
import PrintHeader from '../../components/print/PrintHeader'
import PrintSubHeader from '../../components/print/PrintSubHeader'
import PrintWellAnnotatedEventTable from '../../components/print/PrintWellAnnotatedEventTable'
import PrintClinicNotes from '../../components/print/PrintClinicNotes'
import PrintPageHeader from '../../components/print/PrintPageHeader'
import PrintWellDetail from '../../components/print/PrintWellDetail'
import PrintWellScoreMetrics from '../../components/print/PrintWellScoreMetrics'

export default {
    name: 'PrintWell',
    components: {
        PrintWellScoreMetrics,
        PrintWellDetail,
        PrintPageHeader,
        PrintClinicNotes,
        PrintWellAnnotatedEventTable,
        PrintSubHeader,
        PrintHeader,
        WellStatusControls
    },
    data() {
        return {
            isImageLoading: true
        }
    },
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell
        }),
        imageUrl() {
            const lastEventWithImage = Utils.getLastMkEventWithImage(this.focusedWell)
            return lastEventWithImage && lastEventWithImage.imageUrl
                ? lastEventWithImage.imageUrl
                : this.focusedWell.lastImageUrl
        }
    },
    mounted() {
        this.loadWellData()
    },
    methods: {
        async loadWellData() {
            await this.$store.dispatch('timelapse/setWellData', {
                forceFullReload: false,
                route: this.$route
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@page {
    size: landscape;
    margin: 0;
}

.print-well {
    display: block;
    position: relative;
    background-color: $dark;
    padding-top: 100px;
    min-height: 100vh;
    color: black;

    .print_content {
        position: relative;
        display: block;
        margin: 0 auto;
        width: 1122.519685px; // when using mm the result isn't consistent per screen
        min-height: 100vh;

        @media print {
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            page-break-before: always;
        }

        * {
            pointer-events: none;
        }

        .page {
            display: block;
            position: relative;
            height: 867px; // when using mm the result isn't consistent per screen
            width: 1122.519685px; // when using mm the result isn't consistent per screen
            padding: 20px; // to match margin of printer page
            margin-bottom: 5px;
            background-color: $light-3;

            @media print {
                margin-bottom: 0;
                background: none;
                width: 100%;
                height: 100%;
            }

            .key-score-metrics {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                column-gap: 10px;
                width: 250px;
                margin-block: 1rem;
            }

            .well-body {
                display: grid;
                grid-template-columns: repeat(3, 1fr);

                .center {
                    margin-inline: 3rem;
                }

                .right {
                    .well-status-container {
                        display: flex;
                        justify-content: end;
                    }
                    .img-container {
                        margin-inline: 10px;
                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }

    @media print {
        background: none;
        margin: 0;
        padding: 0;

        * {
            -webkit-print-color-adjust: exact;
        }
    }
}
</style>

<style lang="scss">
@media print {
    body,
    html,
    #wrapper {
        width: 100% !important;
        height: 100% !important;
        display: block;
        background: none;
    }
}

.print-well {
    color: $dark-6;

    .well-status-controls {
        .btn-dark {
            background-color: $white !important;
            border: 1px solid $white !important;

            &.active {
                border: 1px solid $light !important;

                i {
                    color: $light !important;
                }
            }

            i {
                -webkit-text-stroke: unset !important;
            }
        }
    }
}
</style>
